export const VideoCarouselSkeleton = () => {
  return (
    <div className="flex w-full flex-col gap-5">
      <div className="h-20 w-full animate-pulse rounded-lg bg-skeleton" />
      <div className="mt-3 flex flex-col gap-4 md:flex-row">
        <div className="h-[500px] w-[300px] animate-pulse rounded-lg bg-skeleton " />
        <div className="h-[500px] w-[300px] animate-pulse rounded-lg bg-skeleton " />
        <div className="h-[500px] w-[300px] animate-pulse rounded-lg bg-skeleton " />
      </div>
    </div>
  )
}
